import actions from './actions';

const {
  LIST_SERVICIO,
  LIST_SERVICIO_SELECTBOX,
  CREATE_SERVICIO,
  READ_SERVICIO,
  UPDATE_SERVICIO,    
} = actions;

const initialState = {
  data: [],
  dataSelectBox: [],
  record: {},  
};


const servicioCrudReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LIST_SERVICIO:
      return {
        ...state,
        data: data
      }
    case LIST_SERVICIO_SELECTBOX:
      return {
        ...state,
        dataSelectBox: data
      }
    case CREATE_SERVICIO:
      return {
        ...state,
        record: data
      }
    case READ_SERVICIO:
      return {
        ...state,
        record: data
      }
    case UPDATE_SERVICIO:
      return {
        ...state,
        record: data
      }
    default:
      return state;
  }
};


export default servicioCrudReducer;
